module.exports = __webpack_public_path__ + "static/media/sf logo.872b26fe.png";